import { styled } from '@clickcease/cc-client-components-lib'

export const AccountsAndPlansStyles = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '$9',
})

export const AccountsAndPlansRow = styled('div', {
  width: '450px',
  minHeight: '64px',
  display: 'flex',
  marginLeft: '$3',
})

export const AccountAndPlansWrapper = styled('div', {
  height: '256px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
})

export const AccountsAndPlansTitlesWrapper = styled('div', {
  display: 'flex',
  fontSize: '$sm',
  marginBottom: '$6',
})

export const AccountAndPlansTitle = styled('div', {
  width: '50%',
})
export const AccountsAndPlansAccountName = styled('div', {
  lineHeight: '64px',
  width: '44%',
  textTransform: 'capitalize',
  fontWeight: '$l',
  fontSize: '$md',
  variants: {
    bundle: {
      true: {
        lineHeight: '110px',
      },
    },
  },
})
export const AccountsAndPlansPlanDesc = styled('div', { display: 'flex', flexDirection: 'column' })
export const AccountPlanDescriptionWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '5px',
})
export const AccountsAndPlansBundle = styled('div', { display: 'flex', flexDirection: 'row' })

export const AccountsAndPlansPlanDescFirstRow = styled('div', {
  marginTop: '$5',
  display: 'flex',
})

export const AccountsAndPlansPlanDescSecondRow = styled('div', {
  fontWeight: '$l',
})
export const AccountsAndPlansPlanType = styled('span', { marginLeft: '$4', fontWeight: '$l' })
export const AccountsAndPlansProductName = styled('span', { fontWeight: '$sb' })
export const ReactivationPageError = styled('div', {
  height: '30px',
  fontWeight: '$xs',
  color: '$error',
  marginTop: '$6',
})

export const ReactivationPageLogout = styled('span', {
  display: 'flex',
  marginTop: '$8',
  fontSize: '$md',
})

export const AccountPlanOptionWrapper = styled('span', {
  borderBottom: '1px solid $lightGray',
  width: '461px',
  paddingLeft: '$5',

  '&:last-of-type': {
    borderBottom: 'none',
  },

  variants: {
    selected: {
      true: {
        background: '$tableHovered',
      },
    },
  },
})
